import RecoTracking from "../RecoTracking";
import { CarouselTrackingData } from "../CarouselTrackingData";
import { GTMRecoTrackingInfo } from "./GTMRecoTrackingInfo";

export default class GTMRecoTracking extends RecoTracking {
  trackRecoClick(data: CarouselTrackingData): void {
    const gtmRecoEvent: GTMRecoTrackingInfo = {
      reco_id: data.placement,
      reco_location: data.placement,
      reco_rule: data.strategy,
      event: "reco.click",
    };
    window.dataLayer?.push(gtmRecoEvent);
  }

  trackRecoImpression(data: CarouselTrackingData): void {
    const gtmRecoEvent: GTMRecoTrackingInfo = {
      reco_id: data.placement,
      reco_location: data.placement,
      reco_rule: data.strategy,
      event: "reco.impression",
    };
    window.dataLayer?.push(gtmRecoEvent);
  }
}
